<template>
  <section class="section container">
    <div class="container mt-0 mb-6">
      <h1 class="title is-4 mb-3 is-pulled-right">
        {{ $t("shortkey module settings") }}
      </h1>
    </div>

    <h1 class="title is-5">{{ $t("settings") }}</h1>
    <div class="columns mt-0">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("shortkey for show terminal") }}</label>
          <div class="control">
            <input
              class="input"
              type="text"
              v-model="meta.shortkey_show_terminal"
              placeholder="ctrl+shift+x"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{
            $t("shortkey for show command palette")
          }}</label>
          <div class="control">
            <input
              class="input"
              type="text"
              v-model="meta.shortkey_show_command_palette"
              placeholder="ctrl+shift+/"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("shortkey for home") }}</label>
          <div class="control">
            <input
              class="input"
              type="text"
              v-model="meta.shortkey_home"
              placeholder="ctrl+Home"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="container mt-6">
      <div class="field mt-5">
        <div class="control">
          <button class="button is-rounded is-primary" @click="save">
            <span class="icon"><i class="fa fa-save"></i></span>
            <span>{{ $t("save") }}</span>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  save_configuration,
  get_configuration,
  post,
  error_message,
  success_message,
} from "@/utils";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "ShortcutSettings",
  components: { GenericDropdown },
  data() {
    return {
      meta: {},
    };
  },
  methods: {
    save() {
      let v = this;
      let data = v.meta;
      v.$root.loader(true);
      save_configuration(this, data)
        .then((response) => {
          console.log("configuration saved", response);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => v.$root.loader(false));
    },
  },
  created() {
    let v = this;
    v.$root.loader(true);
    get_configuration(this)
      .then((conf) => {
        if (conf) v.meta = conf;
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => v.$root.loader(false));
  },
};
</script>

<style></style>
